<template>
    <div class="content">
      <ph-header>
        <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
      </ph-header>
      <section class="address-wrapper">
        <van-address-edit
          :area-list="areaList"
          :is-saving="isSaving"
          show-set-default
          @save="onSave"
        />
      </section>
    </div>
</template>

<script>
// import areaList from '@/utils/areaList.js'
import PhHeader from '@/components/common/Header'
import { AddressEdit } from 'vant'
import { initAreaList, postAddressEdit } from '@/api/user'
export default {
  data () {
    return {
      isSaving: false,
      params: {
        editType: 1, // 新增标示
        userToken: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        connection: '',
        detailedAddress: '',
        tel: '',
        receiver: '',
        defaultAddress: 2
      }
    }
  },
  components: {
    PhHeader,
    [AddressEdit.name]: AddressEdit
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
    areaList () {
      let _areaList = this.$store.getters.defaultAreaList
      return _areaList || this.getInitAreaList()
    },
    areaCodeToId () {
      let map = this.$store.getters.defaultAreaList.correspondingDictionary
      return map || this.getInitAreaList()
    }

  },
  methods: {
    getInitAreaList () {
      initAreaList().then(res => {
        this.$store.commit('SET_DEFAULT_AREA_LIST', res)
      }).catch(err => {
        this.$toast(err)
      })
    },
    onSave (content) {
      this.isSaving = true

      this.params.userToken = this.token
      this.params.receiver = content.name
      this.params.tel = content.tel
      this.params.defaultAddress = content.isDefault ? '1' : '2'

      this.params.provinceId = this.areaCodeToId[content.areaCode.slice(0, 2) + '0000']
      this.params.cityId = this.areaCodeToId[content.areaCode.slice(0, 4) + '00']
      this.params.areaId = this.areaCodeToId[content.areaCode]
      this.params.connection = `${content.province}${content.city}${content.county}`

      this.params.detailedAddress = content.addressDetail

      postAddressEdit(this.params).then(res => {
        this.isSaving = false
        this.$toast('添加成功')
        this.$router.replace({ name: 'address' })
      }).catch(err => {
        this.$toast(err)
        this.isSaving = false
      })
    }

  }
}
</script>

<style lang="less" scoped>

</style>
